// extracted by mini-css-extract-plugin
export default {"featuredArtists":"FeaturedArtists-module_featuredArtists__aJ328","contain":"FeaturedArtists-module_contain__h9Q7A","richText":"FeaturedArtists-module_richText__F_YnT"};